import { useState } from 'react';

interface UseKeyboardConfig {
  delete: string;
  clear: string;
}

/**
 * useKeyboard is an extension of useState that has the common keyboard
 * and numpad value change functionality built into it.
 * @param {*} initialValue - the initial string value to pass in
 * @param {*} config - Configurations to set for keyboard clear and delete string
 */

export function useKeyboard(
  initialValue: string | (() => string),
  config: UseKeyboardConfig = { delete: 'delete', clear: 'clear' }
): [string, (v: string) => void] {
  const [value, setValue] = useState(initialValue);

  /*
  // sets the value
  // if the value is equal to the config.delete - remove one character
  // if the value is equal to the config.clear - remove all characters
  // else add the new character onto previous character
  */
  const setKeyValue = (v: string) => {
    if (v === config.delete) return setValue(initial => initial.slice(0, -1));
    if (v === config.clear) return setValue('');
    return setValue(initial => initial + v);
  };

  // returns the current value and the function to set the new value
  return [value, setKeyValue];
}
